import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';

@Component
export class BodyOverlay extends ThemeComponent {
    private close: string = 'overlay-clicked';
    private _onCloseChange = new SimpleEvent<string>();
    public get onCloseChange() {
        return this._onCloseChange.asEvent();
    }

    init() {
        /**
            * When other components render before BodyOverlay, trigger this event
            * to initialise other components to trigger events
        */
        document.dispatchEvent(new Event('bodyOverlayLoaded'));

        this.$listen(this, 'click', () => {
            this._onCloseChange.dispatch(this.close);
            this.closeOverlay();
        });
    }

    public openOverlay() {
        this.classList.remove('visibility-hidden');
    }

    public closeOverlay() {
        this.classList.add('visibility-hidden');
    }
}
